import ModelUtil from '@leverege/model-util';
import LinearScaleModel from "../scale/LinearScaleModel.js";
function create(type, extend) {
  return {
    type,
    scale: LinearScaleModel.create(),
    label: null,
    ...extend
  };
}
export default {
  create,
  ...ModelUtil.createAllValue('scale'),
  ...ModelUtil.createAllValue('label')
};